import React from 'react';
import CiberCticontent from '../components/CiberCtiContent';
import Footer from '../components/footer';

const CiberCtipage = () => {
  return (
    <div className="Ciberseg">
         
          <CiberCticontent />
          <Footer />
    </div>
  );
}

export default CiberCtipage;